import { Link } from "react-router-dom";
import styles from "./ProductCard.module.css";

export default function ProductCard({ name, image, path }) {
  const inner = (
    <article className={styles.card}>
      <img className={styles.image} src={image} alt={name} />
      <div className={styles.content}>
        <h3>{name}</h3>
      </div>
    </article>
  );
  if (!path) return inner;
  return (
    <Link to={path} className={styles.cardLink} aria-label={`Shop ${name}`}>
      {inner}
    </Link>
  );
}
